import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
export const HealthWorkOrderProposalV1Schema = z
    .object({
    schemaVersion: z.literal("health-work-order-proposal.v1.0"),
    proposalId: z.string(),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    sourceMonitorId: z.string(),
    scopeSummary: z.string(),
    requiresOperatorApproval: z.literal(true),
    businessGraphMutation: z.literal(false),
    createdAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=care-health-work-order.js.map